import React from "react";

export default () => (
  <svg
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-[24px] h-[24px]"
  >
    <path
      d="M15.5002 0C6.99016 0 0.0834961 6.72 0.0834961 15C0.0834961 23.28 6.99016 30 15.5002 30C24.0102 30 30.9168 23.28 30.9168 15C30.9168 6.72 24.0102 0 15.5002 0ZM15.5002 6C18.4756 6 20.896 8.355 20.896 11.25C20.896 14.145 18.4756 16.5 15.5002 16.5C12.5247 16.5 10.1043 14.145 10.1043 11.25C10.1043 8.355 12.5247 6 15.5002 6ZM15.5002 27C12.3706 27 8.67058 25.77 6.03433 22.68C8.73472 20.6186 12.0678 19.4982 15.5002 19.4982C18.9325 19.4982 22.2656 20.6186 24.966 22.68C22.3297 25.77 18.6297 27 15.5002 27Z"
      fill="black"
    />
  </svg>
);
